import { BoundingBox } from "@/types/util"

import { MapDisplayType } from "@/components/map/map-controls"

export const NEARBY_ZOOM_THRESHOLD = 13.5
export const FOCUSED_PLACE_ZOOM = 13.95
export const MAP_REFERENCE_PLACES_MIN_ZOOM = 10

export const TRIP_PAGE_MAP_ID = "trip-page-map"
export const TRIP_SHEET_MAP_ID = "trip-sheet-map"

export const DEFAULT_BBOX: BoundingBox = [-180, -85, 180, 85]
export const DEFAULT_ZOOM = 2.5
export const DEFAULT_CENTER = { lat: 0, lng: 0 }
export const DEFAULT_PADDING: google.maps.Padding = { bottom: 12 }
export const DEFAULT_MAP_DISPLAY_TYPE: MapDisplayType = "roadmap"
export const DEFAULT_RESTRICTION = {
  latLngBounds: {
    north: 85,
    south: -85,
    west: -180,
    east: 180,
  },
}
